module.exports = __webpack_public_path__ + "static/media/banner_resourceforyou-Parents.e072bc45.png";